import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.css';

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

const Breadcrumb = () => {
  const location = useLocation();
  const { pathname } = location;
  if (pathname === '/') return null;
  const segments = pathname.split('/').filter(Boolean);
  let path = '';

  return (
    <nav className="breadcrumb-overlay">
      <div className='container'>
      <Link to="/" className="breadcrumb-link">Home</Link>
      {segments.map((seg, i) => {
        path += '/' + seg;
        const isLast = i === segments.length - 1;
        return (
          <span key={seg}>
            <span className="breadcrumb-sep"> / </span>
            {isLast ? (
              <span className="breadcrumb-current">{capitalize(seg.replace(/-/g, ' '))}</span>
            ) : (
              <Link to={path} className="breadcrumb-link">{capitalize(seg.replace(/-/g, ' '))}</Link>
            )}
          </span>
        );
      })}
      </div>
     
    </nav>
  );
};

export default Breadcrumb; 